import { isStoreAsset } from "../../../../common/features/asset/assetHelpers.ts";
import ListTitleStoreResultCard from "./ListTitleStoreResultCard.tsx";
import ListTitleExploreResultCard from "./ListTitleExploreResultCard.tsx";
import { forwardRef } from "react";
import {
  CompositeAsset,
  StoreAsset,
} from "../../../../common/api/decimal/common-types/manageAssets.ts";

function SearchTitleResult(
  {
    asset,
    lazyLoad,
  }: {
    asset: CompositeAsset<"explore" | "favorite"> | StoreAsset;
    lazyLoad?: boolean;
  },
  ref: React.ForwardedRef<HTMLElement>
) {
  if (isStoreAsset(asset)) {
    return (
      <ListTitleStoreResultCard ref={ref} asset={asset} lazyLoad={lazyLoad} />
    );
  } else {
    return (
      <ListTitleExploreResultCard ref={ref} asset={asset} lazyLoad={lazyLoad} />
    );
  }
}

const Result = forwardRef(SearchTitleResult);

export default Result;
